import React, { useCallback, useState } from 'react';

import Layout from 'elements/layout/layout';
import RequestACallForm, { RequestACallFormFields } from 'organisms/mightyPro/RequestACallForm';
import QualifiedProResponse from 'organisms/requestCallForm/QualifiedProResponse';
import QualifiedBusinessResponse from 'organisms/requestCallForm/QualifiedBusinessResponse';
import { PageProps } from 'gatsby';

type FormResponseOutcome = 'qualifiedPro' | 'qualifiedBiz' | 'error';

const RequestACallFormPage = ({ location }: PageProps): JSX.Element => {
  const [ formResult, setFormResult ] = useState<FormResponseOutcome>();

  const onSubmit = useCallback(
    (formFields: RequestACallFormFields) => {
      setFormResult(formFields.isQualifiedPro ? 'qualifiedPro' : 'qualifiedBiz');
    },
    [],
  );

  let content: JSX.Element;
  // TODO create an error response page for feedback
  //  Jira: https://mightynetworks.atlassian.net/browse/FUN-195
  if (!formResult) {
    content = <RequestACallForm onSubmit={onSubmit} />;
  } else if (formResult === 'qualifiedBiz') {
    content = <QualifiedBusinessResponse />;
  } else if (formResult === 'qualifiedPro') {
    content = <QualifiedProResponse />;
  }

  const helmetData = {
    title: 'Request a Call Form | Mighty Networks',
    description: ''
  };

  return (
    <Layout helmet={helmetData} theme="proMinimal" location={location}>
      {content}
    </Layout>
  );
};

export default RequestACallFormPage;
